module.exports = __webpack_public_path__ + "static/map-marker-6cdcc19034469f94417b38d885e5616b.png";